var map = {
	"./0.jpg": "06a0",
	"./1.jpg": "c1a1",
	"./2.jpg": "49d5",
	"./3.jpg": "900c",
	"./4.jpg": "d44a",
	"./5.jpg": "6d5d",
	"./6.jpg": "f2c9",
	"./7.jpg": "5d68"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "09ad";